import request from '../../services/request'

const api = {
  async create(data) {
    const response = await request('/users', {
      method: 'POST',
      body: data
    })

    return response
  }
}

export default api
